var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_001-check-mark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.3 42.3",
    style: {
      enableBackground: "new 0 0 42.3 42.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E98832;}\r\n\t.st1{fill:#F2025D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    className: "st0",
    d: "M18.4,31.6c-0.2,0-0.4-0.1-0.6-0.2l-9-9c-0.3-0.3-0.3-0.8,0-1.2c0,0,0,0,0,0l4.7-4.7 c0.3-0.3,0.8-0.3,1.2,0c0,0,0,0,0,0l3.7,3.7l9.3-9.3c0.3-0.3,0.8-0.3,1.2,0c0,0,0,0,0,0l4.7,4.7c0.3,0.3,0.3,0.8,0,1.2c0,0,0,0,0,0 L19,31.3C18.8,31.5,18.6,31.6,18.4,31.6z M10.6,21.8l7.8,7.8l13.4-13.4l-3.5-3.5L19,22c-0.3,0.3-0.8,0.3-1.2,0c0,0,0,0,0,0l-3.7-3.7 L10.6,21.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    className: "st0",
    d: "M21.2,42.3c-0.5,0-1.1,0-1.6-0.1C7.9,41.3-0.8,31.2,0.1,19.5S11.1-0.8,22.8,0.1 s20.4,11.1,19.5,22.7c-0.3,3.9-1.6,7.6-3.9,10.7c-0.3,0.4-0.8,0.5-1.2,0.2s-0.5-0.8-0.2-1.2c6.3-8.8,4.3-20.9-4.5-27.2 S11.6,1,5.3,9.8S1,30.7,9.8,37c6.8,4.9,15.9,4.9,22.7,0c0.4-0.3,0.9-0.2,1.2,0.2s0.2,0.9-0.2,1.2C29.9,40.9,25.6,42.3,21.2,42.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    className: "st1",
    d: "M35.5,36.4c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8 c0,0.2-0.1,0.4-0.2,0.6C36,36.3,35.8,36.4,35.5,36.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkOrange);
export default __webpack_public_path__ + "static/media/check_mark_orange.b73d02306dc4bf5af2d24d9e10556613.svg";
export { ForwardRef as ReactComponent };